import { Result, Spin } from "antd";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import type { UserRole } from "../../api/auth";
import { getDefaultPathForRole } from "../shell/navigation";
import { useAuth } from "./AuthContext";

export function RequireAuth() {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isLoading) {
    return (
      <div className="route-loading" aria-label="正在验证登录状态">
        <Spin size="large" />
        <span>正在验证安全会话…</span>
      </div>
    );
  }
  if (!auth.user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}

export function RequireRole({ roles }: { roles: readonly UserRole[] }) {
  const { user } = useAuth();
  if (!user || !roles.includes(user.role)) {
    return <Result status="403" title="无权访问" subTitle="当前账号没有进入此模块的权限。" />;
  }
  return <Outlet />;
}

export function AuthenticatedIndexRedirect() {
  const { user } = useAuth();

  return user ? <Navigate to={getDefaultPathForRole(user.role)} replace /> : null;
}
